import styled from 'styled-components';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import Small from 'UIComponents/elements/Small';
import UIIcon from 'UIComponents/icon/UIIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import useILSListSizeEstimate from 'automation-ui-enrollment/hooks/useILSListSizeEstimate';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const StyledUILoadingSpinner = styled(UILoadingSpinner).withConfig({
  displayName: "ILSListSizeEstimateLabel__StyledUILoadingSpinner",
  componentId: "zsjt2n-0"
})(["display:inline-block;position:fixed;"]);
const ILSListSizeEstimateLabel = ({
  filterBranch,
  objectTypeId
}) => {
  const estimateListCountData = useILSListSizeEstimate(filterBranch, objectTypeId);
  if (estimateListCountData.error) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: ['---', /*#__PURE__*/_jsx(Text, {
        paddingBlockEnd: "0",
        marginBlockEnd: "0",
        as: "p",
        children: /*#__PURE__*/_jsxs(Small, {
          use: "error",
          children: [/*#__PURE__*/_jsx(UIIcon, {
            name: "warning",
            className: "p-right-2"
          }), /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
            baseLangKey: "automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromList.listCountError_cob",
            objectTypeId: objectTypeId
          })]
        })
      })]
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: estimateListCountData.loading ? /*#__PURE__*/_jsx(StyledUILoadingSpinner, {
      size: "extra-small",
      className: "p-all-0 m-all-1"
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [estimateListCountData.estimate, /*#__PURE__*/_jsx(Text, {
        paddingBlockEnd: "0",
        marginBlockEnd: "0",
        as: "p",
        children: /*#__PURE__*/_jsx(Small, {
          use: "help",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-enrollment.hybridCalculation.estimateDisclaimer"
          })
        })
      })]
    })
  });
};
export default ILSListSizeEstimateLabel;